import React, {useEffect, useState} from 'react';
import {api} from '../../api';


export default function TagPicker({ selected = [], onChange }) {
  const [tags, setTags] = useState([]);

  useEffect(() => {
    api(`/crm-tags`).then(r => r.json()).then(setTags).catch(() => {});
  }, []);

  const toggle = (tag) => {
    const exists = selected.some(t => t.id === tag.id);
    onChange(exists ? selected.filter(t => t.id !== tag.id) : [...selected, tag]);
  };

  if (tags.length === 0) return <p className="text-sm text-gray-400">No tags defined. <a href="/crm/settings" className="text-blue-600 hover:text-blue-800">Add tags in Settings</a></p>;

  return (
    <div className="flex flex-wrap gap-2">
      {tags.map(tag => {
        const active = selected.some(t => t.id === tag.id);
        return (
          <button key={tag.id} type="button" onClick={() => toggle(tag)}
            className={`px-3 py-1 rounded-full text-sm font-medium border transition-colors ${
              active ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-700 border-gray-300 hover:border-blue-400'
            }`}>
            {tag.name}
          </button>
        );
      })}
    </div>
  );
}
